import { axiosWithAuth } from "helpers";
import { NoteService } from "types";

export const applicationDealNotesService: NoteService = {
	addNote,
	deleteNote,
	editNote,
	getNotes,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getNotes(applicationId, { page }) {
	return axiosWithAuth({
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
		},
		url: `${API_URL}/api/applications/${applicationId}/notes`,
	});
}

function editNote(applicationId, note) {
	return axiosWithAuth({
		method: "PUT",
		data: note,
		url: `${API_URL}/api/applications/${applicationId}/notes/${note.id}`,
	});
}

function addNote(applicationId, note) {
	return axiosWithAuth({
		method: "POST",
		data: note,
		url: `${API_URL}/api/applications/${applicationId}/notes/add`,
	});
}

function deleteNote(applicationId, note) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${API_URL}/api/applications/${applicationId}/notes/${note.id}`,
	});
}
